import { render, staticRenderFns } from "./product_delist.vue?vue&type=template&id=2b2e3ca0&scoped=true"
import script from "./product_delist.vue?vue&type=script&lang=js"
export * from "./product_delist.vue?vue&type=script&lang=js"
import style0 from "./product_delist.vue?vue&type=style&index=0&id=2b2e3ca0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e3ca0",
  null
  
)

export default component.exports